{
  "CANNED_MGMT": {
    "HEADER": "Mentett válaszok",
    "LEARN_MORE": "Tudjon meg többet a mentett válaszokról",
    "DESCRIPTION": "A mentett válaszok előre megírt válaszsablonok, amelyekkel gyorsan válaszolhat egy beszélgetésben. Az ügynökök a '/' karakter és a rövid kód beírásával szúrhatnak be mentett választ a beszélgetés közben. ",
    "HEADER_BTN_TXT": "Sablon válasz hozzáadása",
    "LOADING": "Sablon válaszok lekérése...",
    "SEARCH_404": "Nincs megfelelő elem.",
    "LIST": {
      "404": "Nincs megfelelő mentett válasz ebben a fiókban.",
      "TITLE": "Mentett válaszok kezelése",
      "DESC": "A sablon válaszok előre definiáltak, amelyek segítségével gyorsan küldhet válaszokat a beszélgetésekre.",
      "TABLE_HEADER": {
        "SHORT_CODE": "Rövid kód",
        "CONTENT": "Tartalom",
        "INBOXES": "Postafiókok",
        "ACTIONS": "Műveletek"
      },
      "ALL_INBOXES": "Minden postafiók",
      "FILTER": {
        "ALL_INBOXES": "Minden postafiók",
        "NO_INBOX": "Nincs postafiók",
        "SEARCH_PLACEHOLDER": "Postafiókok keresése"
      }
    },
    "ADD": {
      "TITLE": "Sablon válasz hozzáadása",
      "DESC": "A sablon válaszok előre definiáltak, amelyek segítségével gyorsan küldhet válaszokat a beszélgetésekre.",
      "CANCEL_BUTTON_TEXT": "Mégse",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Rövid kód",
          "PLACEHOLDER": "Kérjük, adjon meg egy rövid kódot.",
          "ERROR": "Rövid kód szükséges."
        },
        "SUBJECT": {
          "LABEL": "Tárgy (csak e-mail)",
          "PLACEHOLDER": "Opcionális tárgy e-mail válaszokhoz / új beszélgetésekhez"
        },
        "CONTENT": {
          "LABEL": "Üzenet",
          "PLACEHOLDER": "Kérjük, írja meg az üzenetet, amelyet sablonként szeretne elmenteni, hogy később felhasználhassa.",
          "ERROR": "Üzenetre van szükség."
        },
        "ATTACHMENTS": {
          "LABEL": "Mellékletek"
        },
        "INBOXES": {
          "LABEL": "Postafiókok",
          "PLACEHOLDER": "Válasszon postafiókokat (opcionális, hagyja üresen minden postafiókhoz)"
        },
        "SUBMIT": "Elküldés"
      },
      "API": {
        "SUCCESS_MESSAGE": "Sikeresen hozzáadva a sablon válasz.",
        "ERROR_MESSAGE": "Nem sikerült csatlakozni a Woot szerverhez, kérjük próbáld később"
      }
    },
    "EDIT": {
      "TITLE": "Sablon válasz szerkesztése",
      "CANCEL_BUTTON_TEXT": "Mégse",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Rövid kód",
          "PLACEHOLDER": "Kérjük, adjon meg egy rövidkódot.",
          "ERROR": "Rövid kód szükséges."
        },
        "SUBJECT": {
          "LABEL": "Tárgy (csak e-mail)",
          "PLACEHOLDER": "Opcionális tárgy e-mail válaszokhoz / új beszélgetésekhez"
        },
        "CONTENT": {
          "LABEL": "Üzenet",
          "PLACEHOLDER": "Kérjük, írja meg az üzenetet, amelyet sablonként szeretne elmenteni, hogy később felhasználhassa.",
          "ERROR": "Üzenet kötelező."
        },
        "ATTACHMENTS": {
          "LABEL": "Mellékletek"
        },
        "INBOXES": {
          "LABEL": "Postafiókok",
          "PLACEHOLDER": "Válasszon postafiókokat (opcionális, hagyja üresen minden postafiókhoz)"
        },
        "SUBMIT": "Elküldés"
      },
      "BUTTON_TEXT": "Szerkesztés",
      "API": {
        "SUCCESS_MESSAGE": "A sablon válasz sikeresen frissült.",
        "ERROR_MESSAGE": "Nem sikerült csatlakozni a Woot szerverhez, kérjük próbáld később"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Törlés",
      "API": {
        "SUCCESS_MESSAGE": "A sablon válasz sikeresen törölve.",
        "ERROR_MESSAGE": "Nem sikerült csatlakozni a Woot szerverhez, kérjük próbáld később"
      },
      "CONFIRM": {
        "TITLE": "Törlés megerősítése",
        "MESSAGE": "Biztos abban, hogy törli ",
        "YES": "Igen, törlés ",
        "NO": "Nem, mégse "
      }
    }
  }
}
